import React from 'react';
import { Button } from 'react-bootstrap';

const SimpleModal = ({ children, handleClose, show, alertSize }) => {
    const showHideClassName = show ? "modal display-block" : "modal display-none";

    const handleCloseButton = (e) => {
        e.preventDefault();
        handleClose();
    }

    return (
        <div className={showHideClassName}>
            <section className="modal-main" style={{ height: alertSize.height, width: alertSize.width }}>
                <div style={{ padding: '30px', fontSize: '16pt' }}>
                    {children}
                </div>
                <div className='modal-button-div'>
                    <button type="button" onClick={(e) => handleCloseButton(e)} className="modal-button">Close</button>
                </div>
            </section>
        </div>
    )
}

export default SimpleModal;